/**
 * Constants for analytics event names
 */
export const AnalyticsEventName = {
  // ==========================================
  // USER & AUTH EVENTS
  // ==========================================
  USER_IDENTIFY: 'user_identify',

  // Login Events
  LOGIN_PAGE_VIEW: 'up_login_pageView',
  LOGIN_EMAIL_SUBMITTED: 'up_login_emailSubmitted',
  LOGIN_METHOD_SELECTED: 'up_login_methodSelected',
  LOGIN_PASSWORD_SUBMITTED: 'up_login_passwordSubmitted',
  LOGIN_VERIFICATION_CODE_SUBMITTED: 'up_login_verificationCodeSubmitted',
  LOGIN_GOOGLE_CLICKED: 'up_login_googleClicked',
  LOGIN_SUCCESS: 'up_login_success',
  LOGIN_ERROR: 'up_login_error',
  LOGIN_RESEND_CODE_CLICKED: 'up_login_resendCodeClicked',
  LOGIN_RESEND_CODE_SUCCESS: 'up_login_resendCodeSuccess',
  LOGIN_RESEND_CODE_ERROR: 'up_login_resendCodeError',

  // Forgot Password Events
  FORGOT_PASSWORD_CLICKED: 'up_forgotPassword_clicked',
  FORGOT_PASSWORD_SUBMITTED: 'up_forgotPassword_submitted',
  FORGOT_PASSWORD_SUCCESS: 'up_forgotPassword_success',
  FORGOT_PASSWORD_ERROR: 'up_forgotPassword_error',
  BACK_TO_LOGIN_CLICKED: 'up_backToLogin_clicked',

  // Reset Password Events
  RESET_PASSWORD_PAGE_VIEWED: 'up_resetPassword_pageViewed',
  RESET_PASSWORD_SUBMITTED: 'up_resetPassword_submitted',
  RESET_PASSWORD_SUCCESS: 'up_resetPassword_success',
  RESET_PASSWORD_ERROR: 'up_resetPassword_error',
  GO_TO_LOGIN_CLICKED: 'up_goToLogin_clicked',

  // Resend Access Events
  RESEND_ACCESS_CLICKED: 'up_resendAccess_clicked',
  RESEND_ACCESS_PAGE_VIEWED: 'up_resendAccess_pageViewed',
  RESEND_ACCESS_SUBMITTED: 'up_resendAccess_submitted',
  RESEND_ACCESS_SUCCESS: 'up_resendAccess_success',
  RESEND_ACCESS_ERROR: 'up_resendAccess_error',

  // ==========================================
  // NAVIGATION EVENTS
  // ==========================================
  BREADCRUMB_NAVIGATE: 'up_breadcrumb_navigate',
  PAGE_VIEW: 'page_view',

  // ==========================================
  // HEADER EVENTS
  // ==========================================
  HEADER_NAVIGATE: 'up_header_navigate',
  HEADER_OPEN_OPTION_MENU: 'up_header_openOptionMenu',
  HEADER_USER_MENU: 'up_header_userMenu',
  HEADER_NAV_MENU: 'up_header_navMenu',

  // ==========================================
  // FOOTER EVENTS
  // ==========================================
  FOOTER_NAVIGATE: 'up_footer_navigate',

  // ==========================================
  // SEARCH EVENTS
  // ==========================================
  SEARCH_BAR_SEARCH: 'up_searchBar_search',
  SEARCH_RESULT_VIEW: 'up_searchResult_view',
  SEARCH_RESULT_FILTER: 'up_searchResult_filter',
  SEARCH_RESULT_FILTER_RESULT: 'up_searchResult_filterResult',
  SEARCH_RESULT_OPEN_CONTENT: 'up_searchResult_openContent',
  SEARCH_RESULT_OPEN_PARTNER_CONTENTS: 'up_searchResult_openPartnerContents',
  SEARCH_RESULT_SHOW_ALL_PARTNERS: 'up_searchResult_showAllPartners',

  // ==========================================
  // PARTNER SEARCH EVENTS
  // ==========================================
  PARTNER_SEARCH_RESULT_VIEW: 'up_partnerSearchResult_view',
  PARTNER_SEARCH_RESULT_FILTER: 'up_partnerSearchResult_filter',
  PARTNER_SEARCH_RESULT_FILTER_RESULT: 'up_partnerSearchResult_filterResult',

  // ==========================================
  // HOME EVENTS
  // ==========================================
  HOME_VIEW: 'up_home_view',
  HOME_OPEN_CONTENT: 'up_home_openContent',
  HOME_OPEN_ALL_PARTNERS: 'up_home_openAllPartners',
  HOME_OPEN_PARTNER_CONTENTS: 'up_home_openPartnerContents',
  HOME_OPEN_CONTENTS_SKILL: 'up_home_openContentsSkill',
  HOME_OPEN_ALL_ONGOING_CONTENTS: 'up_home_openAllOngoingContents',
  HOME_OPEN_ONGOING_CONTENT: 'up_home_openOngoingContent',
  HOME_EDIT_SKILL: 'up_home_editSkill',
  HOME_OPEN_AVAILABLE_CATEGORY: 'up_home_openAvailableCategory',

  // ==========================================
  // CONTENT EVENTS
  // ==========================================
  CONTENT_VIEW: 'up_content_view',
  CONTENT_ENROLL: 'up_content_enroll',
  CONTENT_OPEN_PARTNER_SITE: 'up_content_openPartnerSite',
  CONTENT_OPEN_DIALOG_PARTNER_CONFIRMATION: 'up_content_openDialogPartnerConfirmation',
  CONTENT_DISMISS_DIALOG_PARTNER_CONFIRMATION: 'up_content_dismissDialogPartnerConfirmation',
  CONTENT_OPEN_PARTNER_PAGE: 'up_content_openPartnerPage',
  CONTENT_SEE_REVIEWS: 'up_content_seeReviews',
  CONTENT_FAQ: 'up_content_faq',
  CONTENT_PAGE_RECOMMENDED_PARTNER: 'up_contentPage_recommendedPartner',
  CONTENT_PAGE_RECOMMENDED_COURSE: 'up_contentPage_recommendedCourse',
  CONTENT_RECOMMENDED_LIST_VIEW: 'up_content_recommendedListView',

  // ==========================================
  // FIT-SCORE EVENTS
  // ==========================================
  FIT_SCORE_WHATSAPP_CLICK: 'up_fitscore_whatsappClick',
  FIT_SCORE_RECOMMENDATIONS_OPEN_CONTENT: 'up_fitscoreRecommendations_openContent',

  // ==========================================
  // ENROLLMENT FORM EVENTS
  // ==========================================
  ENROLL_FORM_VIEW: 'up_enrollForm_view',
  ENROLL_FORM_ADD_SKILL: 'up_enrollForm_addSkill',
  ENROLL_FORM_REMOVE_SKILL: 'up_enrollForm_removeSkill',
  ENROLL_FORM_BACK: 'up_enrollForm_back',
  ENROLL_FORM_CONTINUE: 'up_enrollForm_continue',
  ENROLL_FORM_CONTINUE_ERROR: 'up_enrollForm_continueError',

  // ==========================================
  // ENROLLMENT REVIEW EVENTS
  // ==========================================
  ENROLL_REVIEW_VIEW: 'up_enrollReview_view',
  ENROLL_REVIEW_BACK: 'up_enrollReview_back',
  ENROLL_REVIEW_SUBMIT: 'up_enrollReview_submit',
  ENROLL_REVIEW_SUBMIT_ERROR: 'up_enrollReview_submitError',

  // ==========================================
  // ENROLLMENT REQUEST EVENTS
  // ==========================================
  ENROLL_REQUEST_VIEW: 'up_enrollRequest_view',
  ENROLL_REQUEST_SUBMITING: 'up_enrollRequest_submiting',
  ENROLL_REQUEST_TRY_AGAIN: 'up_enrollRequest_tryAgain',
  ENROLL_REQUEST_AUTH_ERROR: 'up_enrollRequest_authError',
  ENROLL_REQUEST_AUTH_FINISHED: 'up_enrollRequest_authFinished',
  ENROLL_REQUEST_AUTH_SELECT_THIS_DEVICE: 'up_enrollRequest_authSelectThisDevice',
  ENROLL_REQUEST_AUTH_TRY_AGAIN: 'up_enrollRequest_authTryAgain',
  ENROLL_REQUEST_MISSING_DATA: 'up_enrollRequest_missingData',

  // ==========================================
  // ENROLLMENT CONFIRMATION EVENTS
  // ==========================================
  ENROLL_CONFIRMATION_VIEW_SUCCESS: 'up_enrollConfirmation_viewSuccess',
  ENROLL_CONFIRMATION_VIEW_ERROR: 'up_enrollConfirmation_viewError',

  // ==========================================
  // ENROLLMENT AGREEMENT EVENTS
  // ==========================================
  ENROLL_ACCEPT_ALL_AGREEMENT_TERM: 'up_enroll_acceptAll_agreementTerm',
  ENROLL_AGREEMENT_TERM_STEP: 'up_enroll_agreementTermStep',

  // ==========================================
  // ENROLLMENT WORKFLOW EVENTS
  // ==========================================
  ENROLLMENT_WORKFLOW_STAGE_ACTION_CLICKED: 'enrollment_workflow_stage_action_clicked',
  ENROLLMENT_WORKFLOW_STAGE_COLLAPSED: 'enrollment_workflow_stage_collapsed',
  ENROLLMENT_WORKFLOW_STAGE_EXPANDED: 'enrollment_workflow_stage_expanded',

  // ==========================================
  // USER ENROLLMENTS EVENTS
  // ==========================================
  ENROLLMENTS_VIEW: 'up_enrollments_view',
  ENROLLMENTS_OPEN_CONTENT: 'up_enrollments_openContent',

  // ==========================================
  // ENROLLMENT DETAIL EVENTS
  // ==========================================
  ENROLLMENT_DETAIL_VIEW: 'up_enrollment_detail_view',
  ENROLLMENT_DETAIL_CANCEL: 'up_enrollment_detail_cancel',
  ENROLLMENT_DETAIL_CBU: 'up_enrollment_detail_cbu',
  ENROLLMENT_DETAIL_CERTIFICATE: 'up_enrollment_detail_certificate',
  ENROLLMENT_DETAIL_SUPPORT: 'up_enrollment_detail_support',
  ENROLLMENT_DETAIL_LINKEDIN_SHARE: 'up_enrollment_detail_linkedin_share',

  // ==========================================
  // ONBOARDING EVENTS
  // ==========================================
  ONB_START_VIEW: 'up_onbStart_view',
  ONB_START_CONFIRM: 'up_onbStart_confirm',
  ONB_END_CONFIRM: 'up_onbEnd_confirm',

  // Onboarding Step 1
  ONB_STEP1_CONFIRM: 'up_onbStep1_confirm',
  ONB_STEP1_INCORRECT_DATA: 'up_onbStep1_incorrectData',

  // Onboarding Step 2
  ONB_STEP2_CONFIRM: 'up_onbStep2_confirm',
  ONB_STEP2_CONFIRM_ERROR: 'up_onbStep2_confirmError',

  // Onboarding Step 3
  ONB_STEP3_BACK: 'up_onbStep3_back',
  ONB_STEP3_CONFIRM: 'up_onbStep3_confirm',
  ONB_STEP3_CONFIRM_ERROR: 'up_onbStep3_confirmError',
  ONB_STEP3_ADD_LANGUAGE: 'up_onbStep3_addLanguage',
  ONB_STEP3_REMOVE_LANGUAGE: 'up_onbStep3_removeLanguage',

  // Onboarding Step 4
  ONB_STEP4_BACK: 'up_onbStep4_back',

  // Onboarding Step 5
  ONB_STEP5_BACK: 'up_onbStep5_back',

  // Onboarding Step 7
  ONB_STEP7_BACK: 'up_onbStep7_back',
  ONB_STEP7_CONFIRM: 'up_onbStep7_confirm',
  ONB_STEP7_CONFIRM_ERROR: 'up_onbStep7_confirmError',
  ONB_STEP7_OPEN_PRIVACY_POLICY: 'up_onbStep7_openPrivacyPolicy',
  ONB_STEP7_OPEN_TERMS: 'up_onbStep7_openTerms',
  ONB_STEP7_TERMS_CHECK: 'up_onbStep7_termsCheck',

  // Onboarding Basic Personal Data
  ONB_BASIC_PERSONAL_DATA_CONFIRM: 'up_onbBasicPersonalData_confirm',
  ONB_BASIC_PERSONAL_DATA_CONFIRM_ERROR: 'up_onbBasicPersonalData_confirmError',

  // Onboarding Career Moment
  ONB_CAREER_MOMENT_BACK: 'up_onbCareerMoment_back',
  ONB_CAREER_MOMENT_CONFIRM: 'up_onbCareerMoment_confirm',
  ONB_CAREER_MOMENT_CONFIRM_ERROR: 'up_onbCareerMoment_confirmError',
  ONB_CAREER_MOMENT_SELECT: 'up_onbCareerMoment_select',

  // Onboarding Content Types
  ONB_CONTENT_TYPES_BACK: 'up_onbContentTypes_back',
  ONB_CONTENT_TYPES_CONFIRM: 'up_onbContentTypes_confirm',
  ONB_CONTENT_TYPES_CONFIRM_ERROR: 'up_onbContentTypes_confirmError',
  ONB_CONTENT_TYPES_SELECT: 'up_onbContentTypes_select',

  // Onboarding Content Formats
  ONB_CONTENT_FORMATS_BACK: 'up_onbContentFormats_back',
  ONB_CONTENT_FORMATS_CONFIRM: 'up_onbContentFormats_confirm',
  ONB_CONTENT_FORMATS_CONFIRM_ERROR: 'up_onbContentFormats_confirmError',

  // ==========================================
  // LEARNING OBJECTIVES EVENTS
  // ==========================================
  LEARNING_OBJECTIVES_BACK: 'up_LearningObjectives_back',
  LEARNING_OBJECTIVES_CONFIRM: 'up_LearningObjectives_confirm',
  LEARNING_OBJECTIVES_CONFIRM_ERROR: 'up_LearningObjectives_confirmError',

  // ==========================================
  // CONTACT VERIFICATION EVENTS
  // ==========================================
  CONTACT_VERIFICATION_PAGE_VIEW: 'up_contactVerificationPage_view',
  CONTACT_VERIFICATION_CONFIRM: 'up_contactVerification_confirm',
  CONTACT_VERIFICATION_CONFIRM_ERROR: 'up_contactVerification_confirmError',
  CONTACT_VERIFICATION_EMAIL: 'up_contactVerification_email',
  CONTACT_VERIFICATION_PHONE: 'up_contactVerification_phone',
  CONTACT_VERIFICATION_RESEND: 'up_contactVerification_resend',
  CONTACT_VERIFICATION_SKIP: 'up_contactVerification_skip',
  CONTACT_VERIFICATION_SUCCESS_CONTINUE: 'up_contactVerification_successContinue',
  CONTACT_VERIFICATION_SUCCESS_VIEW: 'up_contactVerification_successView',
  CONTACT_VERIFICATION_VALIDATE: 'up_contactVerification_validate',

  // ==========================================
  // SKILLS EVENTS
  // ==========================================
  SKILLS_ADD: 'up_skills_add',
  SKILLS_CONFIRM: 'up_skills_confirm',
  SKILLS_CONFIRM_ERROR: 'up_skills_confirmError',
  SKILLS_REMOVE: 'up_skills_remove',

  // ==========================================
  // INTEREST AREAS EVENTS
  // ==========================================
  INTEREST_AREAS_ADD: 'up_interestAreas_add',
  INTEREST_AREAS_CONFIRM: 'up_interestAreas_confirm',
  INTEREST_AREAS_CONFIRM_ERROR: 'up_interestAreas_confirmError',
  INTEREST_AREAS_REMOVE: 'up_interestAreas_remove',

  // ==========================================
  // FAVORITES EVENTS
  // ==========================================
  FAVORITE_PAGE_VIEW: 'up_FavoritePage_view',
  USER_CONTENT_FAVORITE_ADD: 'up_user_content_favorite_add',
  USER_CONTENT_FAVORITE_REMOVE: 'up_user_content_favorite_remove',

  // ==========================================
  // UPGRADE REQUEST EVENTS
  // ==========================================
  UPGRADE_PAGE_VIEW: 'up_upgradePage_view',
  UPGRADE_PAGE_OPEN_CATALOGUE: 'up_upgradePage_openCatalogue',
  UPGRADE_PAGE_REQUEST: 'up_upgradePage_request',
  UPGRADE_PAGE_REQUEST_ERROR: 'up_upgradePage_requestError',
  UPGRADE_TERMS_BACK: 'up_upgradeTerms_back',
  UPGRADE_TERMS_VIEW: 'up_upgradeTerms_view',
  UPGRADE_REQUEST_SUCCESS: 'up_upgradeRequest_success',
  UPGRADE_REQUEST_SIGN_ERROR: 'up_upgradeRequest_signError',
  UPGRADE_REQUEST_REFUSAL: 'up_upgradeRequest_refusal',

  // ==========================================
  // DEPENDENT REQUEST EVENTS
  // ==========================================
  ADD_DEPENDENT_PAGE_VIEW: 'up_addDependentPage_view',
  ADD_DEPENDENT_PAGE_OPEN_CATALOGUE: 'up_addDependentPage_openCatalogue',
  ADD_DEPENDENT_PAGE_REQUEST: 'up_addDependentPage_request',
  ADD_DEPENDENT_PAGE_REQUEST_ERROR: 'up_addDependentPage_requestError',
  DEPENDENT_TERMS_BACK: 'up_dependentTerms_back',
  DEPENDENT_TERMS_VIEW: 'up_dependentTerms_view',
  DEPENDENT_TERMS_SIGN_ERROR: 'up_dependentTerms_signError',
  DEPENDENT_REQUEST_SUCCESS: 'up_dependentRequest_success',
  DEPENDENT_REQUEST_REFUSAL: 'up_dependentRequest_refusal',

  // ==========================================
  // PROFILE ASSESSMENT EVENTS
  // ==========================================
  PROFILE_ASSESSMENT_CALLBACK: 'up_profileAssessment_callback',
  PROFILE_ASSESSMENT_DISMISS: 'up_profileAssessment_dismiss',
  PROFILE_ASSESSMENT_FINISHED: 'up_profileAssessment_finished',
  PROFILE_ASSESSMENT_OPEN: 'up_profileAssessment_open',

  // ==========================================
  // REQUEST CONFIGURATION EVENTS
  // ==========================================
  REQUEST_CONFIGURATION_CONFIRM: 'up_requestConfiguration_confirm',
  REQUEST_CONFIGURATION_CONFIRM_ERROR: 'up_requestConfiguration_confirmError',

  // ==========================================
  // COMPANY MANAGER EVENTS
  // ==========================================
  HRP_DASHBOARD_VIEW: 'hrp_dashboard_view',
  HRP_DASHBOARD_NAVIGATE: 'hrp_dashboard_navigate',

  // ==========================================
  // SKILL EXPLORER CATALOG EVENTS
  // ==========================================
  SKILL_EXPLORER_CATALOG_LANDING_PAGE_VIEW: 'skill_explorer_catalog_landing_page_view',
  SKILL_EXPLORER_CATALOG_LIST_PAGE_VIEW: 'skill_explorer_catalog_list_page_view',
  SKILL_EXPLORER_CATALOG_LEAD_FORM_SUBMIT: 'skill_explorer_catalog_lead_form_submit',

  // ==========================================
  // CANCEL IDLE ENROLLMENT EVENTS
  // ==========================================
  CANCEL_IDLE_ENROLLMENT_PAGE_VIEW: 'up_cancel_idle_enrollment_Page_view',
  CANCEL_IDLE_ENROLLMENT_CHOICE_MADE: 'up_cancel_idle_enrollment_choice_made',
  CANCEL_IDLE_ENROLLMENT_KNOW_MORE: 'up_cancel_idle_enrollment_know_more',

  // ==========================================
  // ENROLLMENT WINDOW EVENTS
  // ==========================================
  ENROLLMENT_WINDOW_NOTIFY_ME: 'up_enrollmentWindow_notifyMeClicked',
  ENROLLMENT_WINDOW_CANCEL_INTEREST: 'up_enrollmentWindow_cancelInterestClicked',

  // ==========================================
  // CAREER-MENTOR CONTACT REQUEST EVENTS
  // ==========================================
  CAREER_MENTOR_TRIGGER_VIEW: 'up_careerMentorTriggerView',
  CAREER_MENTOR_TRIGGER_CLICKED: 'up_careerMentorTriggerClicked',
  CAREER_MENTOR_PAGE_VIEW: 'up_careerMentorPageView',
  CAREER_MENTOR_REQUEST_MESSAGE_CLICKED: 'up_careerMentorRequestMessageClicked',
  CAREER_MENTOR_WHATSAPP_LINK_CLICKED: 'up_careerMentorWhatsappLinkClicked',

  // ==========================================
  // SCHOLARSHIP RENEWAL EVENTS
  // ==========================================
  SCHOLARSHIP_RENEWAL_COURSE_CHANGED_VIEW: 'up_scholarshipRenewal_courseChanged',
  SCHOLARSHIP_RENEWAL_CONFIRMED_VIEW: 'up_scholarshipRenewal_confirmed',
  SCHOLARSHIP_RENEWAL_COURSE_COMPLETED_VIEW: 'up_scholarshipRenewal_courseCompleted'
} as const

/**
 * Type helper for event names - enables auto-complete and type safety
 */
export type AnalyticsEventNameType = (typeof AnalyticsEventName)[keyof typeof AnalyticsEventName]
